import React from 'react';
import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  variant?: 'default' | 'clausulas' | 'compact';
  closeOnBackdropClick?: boolean;
}

const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  title, 
  onClose, 
  children, 
  variant = 'default',
  closeOnBackdropClick = true 
}) => {
  if (!isOpen) return null;

  // Determinar la clase CSS según la variante
  const getModalClass = () => {
    switch (variant) {
      case 'clausulas':
        return 'modal-content clausulas-modal';
      case 'compact':
        return 'modal-content compact-modal';
      default:
        return 'modal-content';
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="modal-backdrop" 
        onClick={closeOnBackdropClick ? onClose : undefined}
      >
        {/* Modal Content */}
        <div className={getModalClass()} onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="modal-header">
            <h4 className="modal-title">{title}</h4>
            <button className="modal-close-button" onClick={onClose}>
              ✕
            </button>
          </div>
          
          {/* Body - El contenido se pasa como children */}
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;